import getConfig from "./config";
import {isResponsiveBreakpoint} from "./responsive";

const config = getConfig();
const adjustOverlaps = () => {
    [...document.getElementsByClassName("overlap-y")].forEach((overlap) => {
        overlap.style.removeProperty(`${config.prefix}overlap-y`);

        const parentSelector = overlap.getAttribute(
            `data-${config.appName}-overlap-parent-selector`,
        );
        const overlapYPc = Number.parseInt(
            overlap.getAttribute(`data-${config.appName}-overlap-y-pc`),
        );
        const parent = parentSelector
            ? (overlap.closest(parentSelector) ?? overlap)
            : overlap;

        parent.classList.remove("overlap-parent");

        if (Number.isNaN(overlapYPc)) {
            return;
        }

        const overlapBp =
            overlap.getAttribute(`data-${config.appName}-overlap-bp`) || "xxs";
        if (!isResponsiveBreakpoint(overlapBp)) {
            return;
        }

        parent.style.setProperty(`--${config.appName}-loaded`, "0");
        parent.style.setProperty(
            `--${config.appName}-loading-transition-property`,
            getComputedStyle(parent).getPropertyValue(
                `--${config.appName}-loading-transition-property-default`,
            ),
        );
        const overlapBoundingBox = overlap.getBoundingClientRect();
        parent.classList.add("overlap-parent");
        const parentOffsetYDiff = parent.isEqualNode(overlap)
            ? 0
            : parent.getBoundingClientRect().top - overlapBoundingBox.top;
        const overlapYPx =
            (overlapYPc / 100) * overlapBoundingBox.height + parentOffsetYDiff;
        overlap.style.setProperty(
            `${config.prefix}overlap-y`,
            `${overlapYPx}px`,
        );
        overlap.style.setProperty("transform", "none");
        const transitionEnd = () => {
            parent.style.setProperty(
                `--${config.appName}-loading-transition-property`,
                "none",
            );
            parent.removeEventListener("transitionend", transitionEnd);
        };
        parent.addEventListener("transitionend", transitionEnd);
        parent.style.setProperty(`--${config.appName}-loaded`, "1");
    });
};
const setupOverlaps = () => {
    adjustOverlaps();
    window.addEventListener("load", adjustOverlaps);
    window.addEventListener("resize", adjustOverlaps);
};
export {setupOverlaps};
